export const DRAG_TYPE = Symbol('TreeNode')